export enum FieldCommentStatus {
  PENDING = 0,
  RESOLVED_CHANGES,
  RESOLVED_NO_CHANGES,
  VALIDATED
}
